import { render, staticRenderFns } from "./WorkspaceBar.vue?vue&type=template&id=1b36f1d3&scoped=true&"
import script from "./WorkspaceBar.vue?vue&type=script&lang=js&"
export * from "./WorkspaceBar.vue?vue&type=script&lang=js&"
import style0 from "./WorkspaceBar.vue?vue&type=style&index=0&id=1b36f1d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b36f1d3",
  null
  
)

export default component.exports